import type { BrandConfig } from '../types'
import heroImageSrc from './assets/hero.jpg'
import serviceImageSrc from './assets/client.jpg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg';
import testimonial2 from './assets/testimonial-2.svg';
import testimonial3 from './assets/testimonial-3.svg';

const config: BrandConfig = {
  appName: 'manecore',
  brandName: 'manecore',
  description: 'Sistema de agendamento para barbearias',
  logo: {
    src: logoImage,
    alt: 'Logótipo da manecore',
  },
  heroImage: {
    src: heroImageSrc,
    alt: 'Interior de barbearia',
  },
  serviceImage: {
    src: serviceImageSrc,
    alt: 'Barbeiro a atender cliente',
  },
  testimonials: [
		{
			name: 'Ricardo Pereira',
			role: 'Barbearia Clássica',
			text: 'Desde que adotámos o manecore, a nossa produtividade aumentou 30%. É uma ferramenta indispensável!',
			image: testimonial1,
		},
		{
			name: 'Ana Costa',
			role: 'The Modern Barber',
			text: 'Os meus clientes adoram a facilidade de marcar online. Recomendo a 100%.',
			image: testimonial2,
		},
		{
			name: 'Miguel Fernandes',
			role: 'Barber Shop & Co.',
			text: 'A funcionalidade de lembretes automáticos reduziu as faltas em mais de 90%.',
			image: testimonial3,
		},
	],
	terminology: {
		professional: 'barbeiro',
		professionals: 'barbeiros',
		business: 'barbearia',
		businesses: 'barbearias',
		service: 'corte',
		services: 'cortes',
		client: 'cliente',
		clients: 'clientes',
		appointment: 'agendamento',
		appointments: 'agendamentos',
	},
	homepage: {
		hero: {
			badge: 'Solução Completa',
			title: 'Simplifique seus agendamentos com manecore',
			description: 'Aumente a produtividade e ofereça a melhor experiência aos seus clientes com o manecore.',
			ctaPrimary: 'Começar Gratuitamente',
			ctaSecondary: 'Agendar Demonstração',
			features: ['Sem cartão de crédito', 'Configuração em 5 minutos'],
		},
		statistics: [
			{ value: '500+', label: 'Barbearias' },
			{ value: '50k+', label: 'Agendamentos' },
			{ value: '98%', label: 'Satisfação' },
		],
		painPoints: [
			{
				title: 'Marcações por Telefone',
				description: 'Interromper atendimentos para atender chamadas resulta em clientes insatisfeitos e perda de concentração.',
				icon: 'PhoneCall',
				quote: {
					text: 'Perdemos em média 15 minutos por dia apenas atendendo chamadas para agendamentos',
					author: 'João Silva',
					business: 'Barbearia Vintage',
				},
			},
			{
				title: 'Tempo Perdido',
				description: 'Gerir horários manualmente consome tempo que poderia usar para atender mais clientes.',
				icon: 'Clock',
				stats: [
					{ label: 'Tempo perdido por semana:', value: '5 horas' },
					{ label: 'Clientes perdidos por mês:', value: '20+' },
				],
			},
			{
				title: 'Clientes Ausentes',
				description: 'Faltas e cancelamentos de última hora causam prejuízos e horários vazios que poderiam ser preenchidos.',
				icon: 'Users',
				quote: {
					text: 'Reduzimos as faltas em 80% após implementar o sistema de agendamento online',
					author: 'Maria Santos',
					business: 'Barbearia Moderna',
				},
			},
		],
		solution: {
			badge: 'A Solução',
			title: 'manecore: O seu assistente digital',
			description: 'Simplificamos a gestão do seu negócio para que possa focar-se no que realmente importa.',
			features: [
				{
					title: 'Agendamento Online 24/7',
					description: 'Os seus clientes podem marcar horários a qualquer momento, sem precisar telefonar.',
				},
				{
					title: 'Gestão de Clientes',
					description: 'Aceda ao histórico de agendamentos e preferências de cada cliente.',
				},
				{
					title: 'Lembretes Automáticos',
					description: 'Reduza as faltas com lembretes por email ou SMS.',
				},
			],
		},
		testimonials: {
			title: 'O que os nossos clientes dizem',
			description: 'Profissionais que confiam no manecore para crescer.',
		},
		finalCta: {
			title: 'Pronto para simplificar seus agendamentos?',
			description: 'Junte-se a profissionais que já estão a crescer com o manecore.',
			ctaPrimary: 'Começar Gratuitamente',
			ctaSecondary: 'Falar com Consultor',
		},
		contact: {
			title: 'Fale Conosco',
		},
	},
	auth: {
		register: {
			title: 'Criar uma conta',
			description: 'Preencha os dados abaixo para se registrar',
			inviteDescription: 'Crie sua conta para aceitar o convite de barbeiro',
			subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
			inviteCodeLabel: 'Você está usando um código de convite',
			subscriptionLabel: 'Você selecionou um plano de assinatura',
		},
		login: {
			title: 'Entrar na conta',
			description: 'Digite suas credenciais para acessar',
		},
	},
}

export default config 